<template lang="pug">
g-data-table.tieTable(
  :items="items",
  :options.sync="options",
  v-bind="{ headers, subheaders, loading }",
  itemKey="consolidationKey",
  collapsable,
)
  //- show-select,
  template(v-slot:top)
    v-row.table__title
      v-col.h2.primary--text {{ $t('TieManagement.consolidatedOrders') }}
    v-row.table__top
      v-col.py-0
        app-entity-search(
          :criteria="[]",
          @pagination="setPagination",
          :loads="loads",
          :entity="entity",
          :emit="true",
          :rowsPerPage="options.itemsPerPage || null"
          :wheres="pagination.where"
        )
  template(v-slot:item.releaseButton="{ headers, item }")
    g-btn.mx-1(small, color="success", width="90px", :disabled="disableButton(item)" @click.stop="dialog=true; currentTie=item") Release
    v-dialog(v-model='dialog', persistent, width="650", height="443", :retain-focus="false")
      v-card.px-5.py-5
        v-icon.dialog__close.float-right(@click='clearModal') mdi-close
        //- STEP 1: CONFIRM CREATION
        .step-1(v-if="dialogStep==0")
            v-card-text
                v-row.justify-center
                    v-col(cols="auto")
                        v-icon(color="success", size="80") mdi-clipboard-list
                v-row.justify-center
                    v-col(cols="auto")
                        span.dialog-text.h2 {{ $t('TieManagement.releaseConsolidatedOrder') }}
                v-row.justify-center
                    v-col(cols="auto")
                        span.h1 {{currentConsolidationKey}}
                v-row.justify-center
                    v-col(cols="auto")
                        g-btn.h8(color="primary" @click="releaseTie(currentTie)") {{ $t('Common.accept') }}
        //- STEP 2: CREATING/LOADER
        .step-2(v-if="dialogStep==1")
            v-card-text
                v-row.justify-center
                    v-col(cols="auto")
                        v-icon(color="success", size="80") mdi-clipboard-list
                v-row.justify-center
                    v-col(cols="auto")
                        span.dialog-text.h2 {{ $t('TieManagement.creatingShipment') }}
        //- STEP 3: SUCCESS 
        .step-3(v-if="dialogStep==2")
            v-card-text
                v-row.justify-center
                    v-col(cols="auto")
                        v-icon(color="success", size="80") mdi-clipboard-list
                v-row.justify-center
                    v-col(cols="auto")
                        span.dialog-text.h2 {{ $t('TieManagement.shipmentCreated') }}
                v-row.justify-center
                    v-col(cols="auto")
                        span.h1 {{createdShipmentId}}
        //- STEP 4: FAILED 
        .step-3(v-if="dialogStep==3")
            v-card-text
                v-row.justify-center
                    v-col(cols="auto")
                        v-icon(color="error", size="80") mdi-clipboard-list
                v-row.justify-center
                    v-col(cols="auto")
                        span.dialog-text.h2 {{ $t('TieManagement.shipmentCannotBeCreated') }}

  template(v-slot:expanded-item="{ headers, item }")
    td.px-0(:colspan="headers.length")
      v-data-table.internal-table(
        :headers="subheaders",
        :items="item.rows",
        hide-default-footer,
        item-key="id",
        background-color="background",
        disable-pagination,
      )
        //- DateTime format Received At
        template.px-0(v-slot:item.packageReceived="{ subheaders, item }")
          span {{ formatDate(item) }}
        //- EDIT: Orderline
        template.px-0(v-slot:item.editOrderline="{ headers, item }")
            router-link(
                v-if="ShowEntityEdit('OrderLine')",
                style="text-decoration: none",
                :to="`/${$scope()}/OrderLine/${item.orderLineUid}/edit`"
              )
                v-icon.primary--text(small) mdi-pencil
        //- EDIT: Package
        template(v-slot:item.editPackage="{ headers, item }")
            router-link(
                v-if="ShowEntityEdit('Package') && hasPackage(item)",
                style="text-decoration: none",
                :to="`/${$scope()}/Package/${item.packageUid}/edit`"
              )
                v-icon.primary--text(small) mdi-pencil

</template>

<style lang="scss" scoped>
.dialog-text {
    width: 402px !important;
}
</style>

<script>
import axios from 'axios';
import moment from 'moment-timezone';
import EntiyLoadsMixin from "@/mixins/entity-loads.mixin";

export default {
  name: 'TieManagement',
   mixins: [
    EntiyLoadsMixin,
  ],
  data: () => ({
    options: {},
    selected: [],
    items: [],
    filteredItems: [],
    // Same loads as endpoint call on load()
    pagination: {
      where: [
        'x => x.ConsolidationKey.Trim().Length > 0',
      ],
    },
    // Same loads as endpoint call on load()
    loads: [],
    loading: true,
    dialog: false,
    dialogStep: 0,
    currentTie: null,
    createdShipment: null,
  }),
  watch: {
    options: {
      handler(options) {
        this.load(options);
      }
    }
  },
  computed: {
     /* [COMPUTED] Returns the list of headers to be created for the Tie Management table. */
    headers() { 
      return [
        { text: "", value: "releaseButton", sortable: false},
        { text: this.$t('TieManagement.consolidationKey'), value: "consolidationKey", sortable: false },
        { text: this.$t('TieManagement.totalWeight'), value: "totalWeight", sortable: false },
        { text: this.$t('TieManagement.requestedDeliveryDate'), value: "requestedDeliveryDate", type:'DateTime', sortable: false },
        { text: this.$t('TieManagement.deliveryPoint'), value: "deliveryPoint", sortable: false  },
        { text: this.$t('TieManagement.shipToAddress'), value: "shipToAddress", sortable: false },
      ]
    },
    /* 
      [COMPUTED] Returns the list of subheaders to be created for the Tie Management table. 
      This subheaders are the headers of the collapsible subtable which is inside each row of the consolidation table.
    */
    subheaders() { 
      return [
        { text: "", value: "editOrderline", sortable: false},
        { text: this.$t('TieManagement.orderLine'), value: "orderLine", sortable: false},
        { text: this.$t('TieManagement.product'), value: "productText", sortable: false},
        { text: this.$t('TieManagement.status'), value: "status", sortable: false},
        { text: "", value: "editPackage", sortable: false},
        { text: this.$t('TieManagement.caseId'), value: "caseIdentifier", sortable: false},
        { text: this.$t('TieManagement.handlingUnit'), value: "handlingUnit", sortable: false},
        { text: this.$t('TieManagement.weight'), value: "weight", sortable: false},
        { text: this.$t('TieManagement.status'), value: "packageStatus.value", sortable: false},
        { text: this.$t('TieManagement.palletized'), value: "packagePalletized.value", sortable: false},
        { text: this.$t('TieManagement.virtual'), value: "packageVirtual.value", sortable: false},
        { text: this.$t('TieManagement.receivedAt'), value: "packageReceived", sortable: false},
      ]
    },

    entity() {
      var entity = this.$findEntity('OrderLine');
      entity.fields = entity.fields.filter(x => ["consolidationKey","deliveryPoint"].includes(x.name));
      return entity;
    },
    currentConsolidationKey() {
        return _.get(this.currentTie, 'consolidationKey');
    },
    createdShipmentId() {
        return _.get(this.createdShipment, 'externalId');
    },
  },
  methods: {
    async load(options = null) {
      try {
        this.loading = true;
        const pagination = this.getPagination(options, options.where);
        let endpoint = "orderLines/GetConsolidatedTieOrderlines";
        this.items = (await axios.get(endpoint, pagination)).data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    getPagination(options = null, where = null) {
      options = options || this.options;
      if (!_.keys(options).length) return;
      return {
        params: {
          page: options.page,
          pageSize: options.itemsPerPage,
          orderBy: "requestedDeliveryDate",
          desc: true,
          where: where,
        }
      };
    },
    /* [METHOD] Release the tie matching the consolidation key from which the button comes from.
    By releasing a Tie, it will generate a new Shipment from the different Order Lines of many different
    Orders that are relatead by the Key. 
    It returns nothing, simply enable a modal showing progress of the release.*/
    async releaseTie(element) {
        this.dialogStep = 1;

        const endpoint= "orderLines/ReleaseTie";
        try{
            this.createdShipment = (await axios.post(endpoint, element)).data;
            this.dialogStep = 2;
            this.items = [];
            this.load();
        }catch(error){
            console.log("Error [Release Tie]: ", this.$cleanString(error));
            this.dialogStep = 3;
        }
    },
     /* [METHOD] Return the Tie Release progress modal to its default state. */
    clearModal() {
        this.dialogStep = 0;
        this.currentTie = null;
        this.createdShipment = null;
        this.dialog = false;
    },
    /* [METHOD] Returns true if the provied row has packages related to it.
    This is used for deciding to display the edit button at Package level in the table. */
    hasPackage(row){
      let packages = _.get(row, 'packageUid');
      return packages ? true : false;
    },
    /* [METHOD] Returns false if the whole group or consolidation tie meets the requirements to be released.
    This is used for a 'Disabled' property on a button, so that's why returns "negative" value. */
    disableButton(group){
        return !group.rows.every(this.checkConditionsForButton);
    },
    /* [METHOD] Returns true if the pacakge meets the required conditions for the release. 
       package Status has to be Received OR should have ExtraField 'Virtual' as true
    */
    checkConditionsForButton(element, index, array){
      return element && (_.get(element, 'packageStatus.value') == 'Received' || _.get(element, 'packageVirtual.value') == true || _.get(element, 'packageVirtual.value') == 'Y');
    },
    /* [METHOD] Gets a date and returns it formatted for the table. */
    formatDate(input) {
      let packageDate = _.get(input, 'packageReceivedAt.value');
      if(packageDate) return this.$formattedDate(moment(input));
      else return '';
    },
    async setPagination(event) {
      
        await this.load(event);
    },
  },
};
</script>
